import { createStyles } from "@mantine/emotion";

export default createStyles ( {
	stepFourWrapper: {
		display       : "flex",
		flexDirection : "column",
		gap           : "1rem"
	},
	earningCount: {
		fontWeight : "500",
		fontSize   : "2.4rem"
	}
} );